import React from 'react';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { NoImagenIcon } from '../../../../images/icons/WrapSvg';

class Index extends React.Component {
    state = {
        data: [],
    };

    static getDerivedStateFromProps(props, state) {
        const { data } = props;
        if (data !== state.data) {
            state.data = data;
            return state;
        }
        return null;
    }

    handleChange = (index, field, value) => {
        const arr = [...this.state.data];
        arr[index][field] = value;
        this.setState({ data: arr });
    };

    render() {
        const { intl } = this.props;
        const { data } = this.state;

        const NestedTable = (details) => (
            <div className="flex_auto_column margin_bottom_24">
                <Table className={'decrease_table_table'}>
                    <TableBody>
                        {Object.keys(details).map((i) => {
                            const n = details[i];
                            return (
                                <React.Fragment key={randomstring()}>
                                    <TableRow
                                        hover
                                        className={'decrease_table_row hand'}
                                        classes={{ hover: 'decrease_table_hover' }}
                                    >
                                        <TableCell
                                            className={
                                                'barlow_regular_little c_grey_blue nowrap text_align_right'
                                            }
                                            component="th"
                                            scope="row"
                                            colSpan={2}
                                        >
                                            {n.finproduccion}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_little c_grey_blue nowrap center'
                                            }
                                        >
                                            {n.cantidad}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_little c_grey_blue nowrap center'
                                            }
                                        >
                                            {n.merma}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_little c_grey_blue nowrap center'
                                            }
                                        >
                                            {Math.round(((n.merma * 100) / n.cantidad) * 100) / 100}
                                        </TableCell>

                                        <TableCell
                                            className={
                                                'barlow_regular_little c_bluish nowrap center'
                                            }
                                        />
                                    </TableRow>
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        );

        return (
            <Paper className={'decrease_table_paper bg_ice_blue'}>
                <Table className={'decrease_table_table'}>
                    <TableHead>
                        <TableRow className={'decrease_table_row'}>
                            <TableCell />
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'decrease_table_name' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'decrease_table_productions' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'decrease_table_production' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'decrease_table_decrease' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            >
                                {intl.formatMessage({ id: 'decrease_table_decrease_percentage' })}
                            </TableCell>
                            <TableCell
                                className={'barlow_regular_small c_greyish_brown upper center'}
                            />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((n, index) => {
                            return (
                                <React.Fragment key={randomstring()}>
                                    <TableRow
                                        hover
                                        className={'decrease_table_row hand'}
                                        classes={{ hover: 'decrease_table_hover' }}
                                    >
                                        <TableCell className={'center padding_0'} scope="row">
                                            {n.img ? n.img : <NoImagenIcon />}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_small c_dark_grey_blue nowrap'
                                            }
                                            component="th"
                                            scope="row"
                                        >
                                            {n.nombre_producto}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_small c_bluish nowrap center'
                                            }
                                        >
                                            {n.details.length}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_small c_bluish nowrap center'
                                            }
                                        >
                                            {n.cantidad}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_small c_bluish nowrap center'
                                            }
                                        >
                                            {n.merma}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                'barlow_regular_small c_bluish nowrap center'
                                            }
                                        >
                                            {Math.round(((n.merma * 100) / n.cantidad) * 100) / 100}
                                        </TableCell>

                                        <TableCell
                                            className={
                                                'barlow_regular_small c_bluish nowrap center hand'
                                            }
                                        >
                                            {n.mostrar ? (
                                                <ExpandLess
                                                    color="primary"
                                                    className="hand"
                                                    onClick={() =>
                                                        this.handleChange(index, 'mostrar', false)
                                                    }
                                                />
                                            ) : (
                                                <ExpandMore
                                                    color="primary"
                                                    className="hand"
                                                    onClick={() =>
                                                        this.handleChange(index, 'mostrar', true)
                                                    }
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    {n.mostrar && (
                                        <TableRow>
                                            <TableCell
                                                colSpan={7}
                                                children={<NestedTable {...n.details} />}
                                            />
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/reports/decrease/Table.js